// Copyright 2018-2023 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

import InfoCard from "./InfoCard";

export default InfoCard;
